import { getAssetTypeInfo } from "@/utils/assetTypeValidator";

const ASSET_SUBTYPE_LABELS: Record<string, string> = {
  physical: "Physical",
  digital: "Digital",
  retirement: "Retirement",
  savings: "Savings",
  current: "Current",
  fixed: "Fixed",
  recurring: "Recurring",
  term: "Term",
  equity: "Equity",
  debt: "Debt",
  hybrid: "Hybrid",
};

/**
 * Human-readable asset sub-type label (e.g. physical → Physical).
 */
export function formatAssetSubTypeDisplayName(
  subType: string | undefined | null
): string | undefined {
  if (!subType?.trim()) {
    return undefined;
  }

  const normalized = subType.trim();
  const mapped = ASSET_SUBTYPE_LABELS[normalized.toLowerCase()];
  if (mapped) {
    return mapped;
  }

  return formatCategoryDisplayName(normalized);
}

/**
 * Human-readable category label for UI (e.g. bankBalance → Bank Balance).
 */
export function formatCategoryDisplayName(categoryKey: string): string {
  if (!categoryKey) {
    return "Assets";
  }
  const { displayName } = getAssetTypeInfo(categoryKey);
  if (displayName) {
    return displayName;
  }
  return categoryKey
    .replace(/([A-Z])/g, " $1")
    .replace(/_/g, " ")
    .trim()
    .replace(/\b\w/g, (char) => char.toUpperCase());
}
